import { useEffect, useRef, useState } from 'react'

/**
 * Open/close state for a Webflow-style dropdown.
 * Closes on outside click and on Escape. All listeners live inside the effect
 * so nothing touches the DOM during SSR.
 */
export function useDropdown<T extends HTMLElement = HTMLDivElement>() {
    const [open, setOpen] = useState(false)
    const ref = useRef<T>(null)

    useEffect(() => {
        if (!open) return

        function handlePointer(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setOpen(false)
            }
        }

        function handleKey(event: KeyboardEvent) {
            if (event.key === 'Escape') setOpen(false)
        }

        document.addEventListener('mousedown', handlePointer)
        document.addEventListener('keydown', handleKey)

        return () => {
            document.removeEventListener('mousedown', handlePointer)
            document.removeEventListener('keydown', handleKey)
        }
    }, [open])

    return { open, setOpen, ref }
}
